import { Component } from '@angular/core';

@Component({
  selector: 'app-password-entry-dialog',
  templateUrl: './password-entry-dialog.component.html',
  styleUrls: ['./password-entry-dialog.component.scss']
})
export class PasswordEntryDialogComponent {

}
